interface LoadingProps {
    size?: 'xs' | 'sm' | 'md' | 'lg';
    className?: string;
}

export const Loading = ({ size = 'md', className = '' }: LoadingProps) => {
    const sizeClasses = {
        xs: 'loading-xs',
        sm: 'loading-sm',
        md: 'loading-md',
        lg: 'loading-lg',
    };

    return <span className={`loading loading-spinner ${sizeClasses[size]} ${className}`} role="status" aria-label="Carregando" />;
};
